module.exports = __webpack_public_path__ + "static/media/EID-adha-2024-ar.e2e17a77.jpg";